import {ColumnID, SystemColumnType} from "../../../../../manager/columns/types"

// const debug = "convertOldSettingsColumnId"
const debug = false

/**
 * Converts an old settings column id to the new ColumnID format.
 * If the id matches any SystemColumnType, it is returned as a SystemColumnType.
 * Otherwise, it is treated as a custom field and returned as a CFString ("CF-" + id).
 * 
 * @param id - The old column id as a string.
 * @returns The updated ColumnID (SystemColumnType or CFString).
 */
export default function convertOldSettingsColumnId(id: string): ColumnID {
    const systemColumnTypeValues = Object.values(SystemColumnType)
    debug && console.log(debug, 'process', systemColumnTypeValues.includes(id as SystemColumnType), id, systemColumnTypeValues)

    // Check if the given id exists in SystemColumnType enum values
    if (systemColumnTypeValues.includes(id as SystemColumnType)) {
        // System column: return as SystemColumnType
        return id as SystemColumnType
    } else if (id.startsWith("CF-")) {
        // Already matches CFString format, return as is
        return id as ColumnID
    } else {
        // Custom field: return as CFString in the form "CF-{id}"
        return `CF-${id}`
    }
}